import { useGetCompanyDetail } from "@/api/console/companies/useGetCompany";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import LoadingScreen from "@/components/Loading";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { handleCompanyName } from "@/lib/handleName";
import AssessmentDateCard from "@/src/_components/AssessmentDateCard";
import CompanyCard from "@/src/_components/CompanyCard";
import HistoryCard from "@/src/console/(auth)/companies/[id]/_components/HistoryCard/HistoryCard";
import MemberCard from "@/src/console/(auth)/companies/[id]/_components/MemberCard/MemberCard";
import { LinkRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

function Profile() {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useGetCompanyDetail(id ?? "");
  if (isLoading) return <LoadingScreen />;
  if (!data) return null;

  const company = data.data;
  const { assessment_progresses, company_users, ...companyInfo } = company;
  const breadcrumbs = [
    {
      name: t("companies"),
      href: "/console/companies",
    },
    {
      name: handleCompanyName(company.id, company.company_name),
      href: location.pathname,
    },
  ];
  return (
    <Tabs defaultValue="company info">
      <div className="border-b bg-white">
        <AdminNavbar breadcrumbs={breadcrumbs} />
        <div className="mx-6">
          <div className="mt-8 text-2xl font-bold">
            {handleCompanyName(company.id, company.company_name)}
          </div>
          <div className="mb-8 mt-2 flex items-center gap-1">
            <LinkRegular fontSize={20} />
            {company.homepage_url ? (
              <a href={company.homepage_url} className="text-cyan-600">
                {company.homepage_url}
              </a>
            ) : (
              <span className="text-cyan-600">-</span>
            )}
          </div>
          <TabsList>
            <TabsTrigger value="company info">{t("company-info")}</TabsTrigger>
            <TabsTrigger value="members">{t("member")}</TabsTrigger>
            <TabsTrigger value="history">{t("assessment-history")}</TabsTrigger>
          </TabsList>
        </div>
      </div>
      <TabsContent value="company info">
        <div className="flex h-full gap-14 bg-cool-gray-50 px-6 py-8">
          <div className="grow">
            <CompanyCard
              company={companyInfo}
              onEdit={() => {
                navigate(`/console/companies/${id}/edit`);
              }}
            />
          </div>
          <AssessmentDateCard
            startDate={companyInfo.start_date}
            endDate={companyInfo.end_date}
          />
        </div>
      </TabsContent>
      <TabsContent value="members">
        <div className="h-full bg-cool-gray-50 px-6 py-8">
          <MemberCard companyId={Number(id)} members={company_users} />
        </div>
      </TabsContent>
      <TabsContent value="history">
        <div className="h-full bg-cool-gray-50 px-6 py-8">
          <HistoryCard data={assessment_progresses} />
        </div>
      </TabsContent>
    </Tabs>
  );
}

export default Profile;
